import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, setDoc, doc, getDocs, deleteDoc } from 'firebase/firestore';
import { auth } from './auth';

export default function PrivacyPage() {
  const [content, setContent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSCUser, setIsSCUser] = useState(false);

  // Load Privacy content from Firestore
  async function loadContentFromDB() {
    setLoading(true);
    try {
      const col = collection(db, 'privacy');
      const snapshot = await getDocs(col);
      let loadedContent = '';
      snapshot.forEach(docSnap => {
        const data = docSnap.data();
        if (data && data.content) loadedContent = data.content;
      });
      setContent(loadedContent);
      setError('');
    } catch (err) {
      setError('Failed to load content from database.');
    }
    setLoading(false);
  }

  useEffect(() => {
    loadContentFromDB();
  }, []);

  useEffect(() => {
    // Check if signed-in user is in SC User List
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if (user && user.email) {
        const usersSnapshot = await getDocs(collection(db, 'users'));
        let found = false;
        usersSnapshot.forEach(doc => {
          const data = doc.data();
          if (data.email && data.email.toLowerCase() === user.email.toLowerCase()) {
            found = true;
          }
        });
        setIsSCUser(found);
      } else {
        setIsSCUser(false);
      }
    });
    return () => unsubscribe();
  }, []);

  async function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    setContent('');
    // Read Word file as ArrayBuffer
    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const mammoth = await import('mammoth');
        const arrayBuffer = evt.target.result;
        const options = {
          styleMap: [
            "p[style-name='Title'] => h1:fresh",
            "p[style-name='Subtitle'] => h2:fresh",
            "p[style-name='Heading 1'] => h1:fresh",
            "p[style-name='Heading 2'] => h2:fresh",
            "p[style-name='Heading 3'] => h3:fresh",
            "p[style-name='Heading 4'] => h4:fresh",
            "p[style-name='Heading 5'] => h5:fresh",
            "p[style-name='Heading 6'] => h6:fresh",
            "p[style-name='Quote'] => blockquote:fresh"
          ]
        };
        const result = await mammoth.convertToHtml({ arrayBuffer }, options);
        const html = result.value;
        
        // Remove all existing docs
        const col = collection(db, 'privacy');
        const snapshot = await getDocs(col);
        for (const docSnap of snapshot.docs) {
          await deleteDoc(doc(col, docSnap.id));
        }
        // Save new content
        await setDoc(doc(col, 'main'), { content: html });
        setContent(html);
        setError('');
      } catch (err) {
        setError('Failed to import and save Word file.');
      }
      setLoading(false);
    };
    reader.readAsArrayBuffer(file);
  }

  function handleImportClick() {
    if (!isSCUser) {
      alert('Only SC Users are allowed!');
      return;
    }
    document.getElementById('word-input-privacy').click();
  }

  return (
    <div style={{ padding: 32, maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Privacy Statement</h2>
        {isSCUser && (
          <button onClick={handleImportClick} style={{ marginLeft: 'auto', marginRight: 8 }}>Import from Word</button>
        )}
      </div>
      <input
        id="word-input-privacy"
        type="file"
        accept=".docx"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      {error && <div style={{ color: 'red', marginBottom: 16 }}>{error}</div>}
      {loading && <div style={{ color: '#1976d2', marginBottom: 16 }}>Loading...</div>}
      <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.07)', padding: 24, minHeight: 200 }}>
        {content ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          <div style={{ color: '#888' }}>No content found.</div>
        )}
      </div>
    </div>
  );
}

